import actionTypes from "consts/actionTypes";

export function storeWeCareID(weCareID) {
  return {
    type: actionTypes.SET_WECAREID,
    value: weCareID,
  };
}
export function storeUserMaterials(userMaterials) {
  return {
    type: actionTypes.SET_USER_MATERIALS,
    value: userMaterials,
  };
}



// WEBPACK FOOTER //
// ./src/actions/session.js